import React from 'react';
import ReactQuill from 'react-quill';
import { RewriteSubmittedContext } from 'pages/accountDrawer/emailView/insightsCard';
import { RewriteSequenceInstanceInput } from 'crono-fe-common/types/DTO/rewriteSequenceInstanceInput';
import { RevertRewrittenSequenceInstanceInput } from 'crono-fe-common/types/DTO/revertRewrittenSequenceInstanceInput';
import { SequenceInstance } from 'crono-fe-common/types/sequenceInstance';
import { Prospect } from 'crono-fe-common/types/prospect';
import { ApplySequenceChanges } from 'crono-fe-common/types/DTO/applySequenceChanges';

export interface StrategyOverviewContextType {
  handleRedirectToHome: () => void;
  handleRedirectToTasks: () => void;
  insightsContext: {
    insightsCardRef: React.MutableRefObject<HTMLDivElement | null>;
    insightsButtonRef: React.MutableRefObject<HTMLButtonElement | null>;
    prospect: Prospect | null;
    /**
     * Selects the contact whose sequence the personalize view opens. The
     * ownership travels with the selection because it is only known from the
     * list row: the API refuses to return a non-owned sequence unless the
     * request already carries the on-behalf flag.
     */
    selectProspect: (
      prospectId: string | null,
      options?: { onBehalf?: boolean; sequenceNotOwned?: boolean },
    ) => void;
    /**
     * Whether requests about this selection must act on behalf of an owner —
     * true when the prospect *or* the sequence instance belongs to someone
     * else, because the API checks the prospect. Only ever a request flag.
     */
    selectedOnBehalf: boolean;
    /**
     * Whether the open sequence itself belongs to another user. Drives what the
     * UI withholds, so it must not include contacts the caller enrolled into
     * their own sequence — those are the caller's own work to edit.
     */
    selectedSequenceNotOwned: boolean;
    showInsightTab: boolean;
    setShowInsightTab: React.Dispatch<React.SetStateAction<boolean>>;
    rewriteEnabledMode: RewriteEnabledMode | null;
    setRewriteEnabledMode: React.Dispatch<
      React.SetStateAction<RewriteEnabledMode | null>
    >;
    editorInFocus: ReactQuill | null;
    setEditorInFocus: React.Dispatch<React.SetStateAction<ReactQuill | null>>;
    resetInsightsContext: () => void;
    trackTemplateSaveIfNeeded: (text: string) => void;
    setRewriteSubmittedContext: React.Dispatch<
      React.SetStateAction<RewriteSubmittedContext | undefined>
    >;
    rewriteSequenceInstance: (
      request: RewriteSequenceInstanceInput,
    ) => Promise<void>;
    isRewriteSequenceInstanceInProgress: boolean;
    revertRewrittenSequenceInstance: (
      request: RevertRewrittenSequenceInstanceInput,
    ) => Promise<void>;
    isRevertInProgress: boolean;
    sequenceInstance: SequenceInstance | null;
  };
  startFetchingActiveSequenceChanges: () => void;
  sequenceChangesShorterThan5Minutes: ApplySequenceChanges[];
}
export type RewriteEnabledMode = 'sequenceInstance' | 'template';

export enum StrategyOverviewTab {
  Detail = 'Detail',
  Metrics = 'Metrics',
  Personalise = 'Personalise',
}
